module.exports = __webpack_public_path__ + "static/media/lvjian-zilanghu.25c0141d.jpg";